import ReactDOM from 'react-dom/client';
import { ErrorBoundary, Provider } from '@rollbar/react';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { RollbarErrorFallback } from './RollbarErrorFallback';
import { getRollbarConfig } from './rollbarConfig';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider config={getRollbarConfig()}>
    <ErrorBoundary fallbackUI={RollbarErrorFallback}>
      <App />
    </ErrorBoundary>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
